import React from 'react'

function UserProfile(props) {
  const { profile, isSignin } = props

  const siginIn = isSignin && isSignin === true
  const profilePicture = profile?.content
  const initials = profile?.initials
  const color = profile?.color

  if (profilePicture !== '') {
    return (
      <img
        src={`data:image/png;base64,${profilePicture}`}
        style={{
          width: siginIn ? '40px' : '25px',
          marginLeft: siginIn ? '10px' : 'none',
        }}
        className="img-radius"
        alt="User Profile"
      />
    )
  }

  return (
    <div
      aria-label={initials}
      role="img"
      style={{
        width: siginIn ? '40px' : '25px',
        height: siginIn ? '40px' : '25px',
        cursor: 'pointer',
        borderBottomLeftRadius: '50%',
        borderBottomRightRadius: '50%',
        borderTopRightRadius: '50%',
        borderTopLeftRadius: '50%',
        backgroundColor: color,
        display: 'inline-block',
        boxSizing: 'border-box',
        marginLeft: siginIn ? '10px' : 'none',
      }}
    >
      <div
        style={{
          color: '#F6F6F6',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontStyle: 'inherit',
          fontWeight: 'bold',
        }}
      >
        {initials}
      </div>
    </div>
  )
}

export default UserProfile

